import $, { trim } from "jquery";

$('.products_bba7__product_text a').on('mouseenter', function(){
    $(this).parent().prev().addClass('active');
});

$('.products_bba7__product_text a').on('mouseleave', function(){
    $(this).parent().prev().removeClass('active');
});

